import { useContext } from "react";
import { buildClasses } from "../utils/buildClasses";
import { TransactionColumn } from "./TransactionColumn";
import { TransactionColumnSizer } from "./TransactionColumnSizer";
import { TransactionReviewedIcon } from "./TransactionReviewedIcon";
import { TransactionsNavContext } from "./TransactionsScreen";
import { BreadTransaction, P } from "breadcommon";

export function TransactionColumnHeaderReviewed(): JSX.Element {
  const [transactionsNav, setTransactionsNav] = useContext(
    TransactionsNavContext,
  );

  const reviewedColumnSettings =
    transactionsNav.columnSettings[TransactionColumn.REVIEWED];

  // Derive reviewed filter state from navigation context instead of local state
  const reviewedFilter = (() => {
    if (reviewedColumnSettings.predicate === null) {
      return null;
    }
    // Extract boolean value from the predicate
    const serializable = reviewedColumnSettings.predicate.asSerializable();
    if (
      serializable.name === P.OpName.Equals &&
      serializable.args.length === 2
    ) {
      const literalOp = serializable.args[1];
      if (literalOp.name === P.OpName.Literal) {
        const value = literalOp.args[0];
        if (typeof value === "boolean") {
          return value;
        }
      }
    }
    return null;
  })();

  function rotateBoolean(filterValue: boolean | null): boolean | null {
    if (filterValue === null) {
      return false;
    } else if (filterValue === false) {
      return true;
    } else {
      // if true
      return null;
    }
  }
  function rotateReviewedFilter() {
    const newReviewedFilter = rotateBoolean(reviewedFilter);
    setTransactionsNav((prevState) => ({
      ...prevState,
      columnSettings: {
        ...transactionsNav.columnSettings,
        [TransactionColumn.REVIEWED]: {
          ...reviewedColumnSettings,
          predicate:
            newReviewedFilter === null
              ? null
              : P.Equals(
                  P.Field<BreadTransaction, "reviewed">("reviewed"),
                  P.Literal(newReviewedFilter),
                ),
        },
      },
    }));
  }

  return (
    <TransactionColumnSizer column={TransactionColumn.REVIEWED}>
      <div
        className={buildClasses(
          "w-full",
          "flex",
          "items-center",
          "p-0",
          "justify-center",
        )}
      >
        <div
          className={buildClasses("flex", "items-center", "justify-center")}
          onClick={() => {
            rotateReviewedFilter();
          }}
        >
          <TransactionReviewedIcon reviewed={reviewedFilter} />
        </div>
      </div>
    </TransactionColumnSizer>
  );
}
